import { useState } from "react";
import { mockNotifications, mockUser } from "../../../mocks/account";

export default function NotificationsPanel() {
  const [notifs, setNotifs] = useState(mockNotifications);

  const markAllRead = () => setNotifs((prev) => prev.map((n) => ({ ...n, read: true })));
  const unread = notifs.filter((n) => !n.read).length;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="font-bold text-slate-900 text-xl font-playfair">Benachrichtigungen</h2>
          <p className="text-slate-500 text-sm mt-0.5">{unread > 0 ? `${unread} ungelesen` : "Alles auf dem neuesten Stand"}</p>
        </div>
        {unread > 0 && (
          <button
            onClick={markAllRead}
            className="text-sm text-sky-500 hover:text-sky-600 font-medium cursor-pointer whitespace-nowrap flex items-center gap-1"
          >
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-check-double-line"></i></span>
            Alle als gelesen markieren
          </button>
        )}
      </div>

      <div className="space-y-3">
        {notifs.map((n) => (
          <div
            key={n.id}
            className={`bg-white rounded-xl border p-5 flex items-start gap-4 transition-all duration-200 ${!n.read ? "border-sky-200 shadow-sm" : "border-slate-100 opacity-70"}`}
          >
            <div className={`w-10 h-10 ${n.bg} ${n.color} rounded-xl flex items-center justify-center flex-shrink-0`}>
              <i className={`${n.icon} text-lg`}></i>
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between gap-2">
                <p className="font-semibold text-slate-900 text-sm">{n.title}</p>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <span className="text-slate-400 text-xs whitespace-nowrap">{n.date}</span>
                  {!n.read && <span className="w-2 h-2 bg-sky-500 rounded-full inline-block"></span>}
                </div>
              </div>
              <p className="text-slate-500 text-sm mt-1 leading-relaxed">{n.message}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Notification Preferences */}
      <div className="mt-6 bg-white rounded-2xl border border-slate-100 p-6">
        <h3 className="font-semibold text-slate-800 mb-4">Benachrichtigungseinstellungen</h3>
        <div className="space-y-4">
          {[
            { label: "Kaufbestätigungs-Email", desc: "Erhalt bei jeder Bestellung" },
            { label: "Erinnerung vor der Ziehung", desc: "48 Std. vor jeder Ziehung" },
            { label: "Ziehungsergebnisse", desc: "Sofortige Benachrichtigung über das Ergebnis" },
            { label: "Angebote und neue Pakete", desc: "Aktionen und Neuigkeiten" },
          ].map((pref, i) => (
            <div key={i} className="flex items-center justify-between py-3 border-b border-slate-50 last:border-0">
              <div>
                <p className="text-sm font-medium text-slate-700">{pref.label}</p>
                <p className="text-xs text-slate-400 mt-0.5">{pref.desc}</p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" defaultChecked={i < 3} className="sr-only peer" />
                <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-secondary"></div>
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
